import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

FnrErrorBoundaryError.propTypes = {
  error: PropTypes.object, // error object from a "react-error-boundary" fallback component
};

/*
USAGE: This is to be included in a "react-error-boundary" fallback component so that extra error info renders in dev environment.

import FnrErrorBoundaryError from "UI/FnrErrorBoundaryError";

<FnrErrorBoundaryError error={error} />
*/

export default function FnrErrorBoundaryError({ error }) {
  const isDev = process.env.NODE_ENV === "development";

  if (!isDev) return null;

  return (
    <Wrapper>
      <h3>Error Info</h3>
      <DevOnly>Note: this is only shown in dev environment</DevOnly>
      <pre>{error?.message ?? "(no error object passed to fallback)"}</pre>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-top: 40px;
  padding: 20px;
  background: #efefef;
  border-radius: 20px;

  pre {
    color: red;
    background: #efefef;
    overflow: auto;
  }
`;

const DevOnly = styled.div`
  font-weight: 400;
  margin-top: 10px;
  font-size: 12px;
  opacity: 0.8;
`;
